__turbopack_context__.v({
  "actions": "ingredient-list-module__KfaF-W__actions",
  "amount": "ingredient-list-module__KfaF-W__amount",
  "details": "ingredient-list-module__KfaF-W__details",
  "dietaryWarningBtn": "ingredient-list-module__KfaF-W__dietaryWarningBtn",
  "dietaryWarningIcon": "ingredient-list-module__KfaF-W__dietaryWarningIcon",
  "dietaryWarningPanel": "ingredient-list-module__KfaF-W__dietaryWarningPanel",
  "dietaryWarningRow": "ingredient-list-module__KfaF-W__dietaryWarningRow",
  "dietaryWarningText": "ingredient-list-module__KfaF-W__dietaryWarningText",
  "empty": "ingredient-list-module__KfaF-W__empty",
  "item": "ingredient-list-module__KfaF-W__item",
  "kcalChip": "ingredient-list-module__KfaF-W__kcalChip",
  "list": "ingredient-list-module__KfaF-W__list",
  "name": "ingredient-list-module__KfaF-W__name",
  "namePrep": "ingredient-list-module__KfaF-W__namePrep",
  "noteIcon": "ingredient-list-module__KfaF-W__noteIcon",
  "noteText": "ingredient-list-module__KfaF-W__noteText",
  "notesBtn": "ingredient-list-module__KfaF-W__notesBtn",
  "notesChevron": "ingredient-list-module__KfaF-W__notesChevron",
  "notesChevronOpen": "ingredient-list-module__KfaF-W__notesChevronOpen",
  "notesContent": "ingredient-list-module__KfaF-W__notesContent",
  "prepMethod": "ingredient-list-module__KfaF-W__prepMethod",
  "quantityUnit": "ingredient-list-module__KfaF-W__quantityUnit",
  "row": "ingredient-list-module__KfaF-W__row",
  "thumbnail": "ingredient-list-module__KfaF-W__thumbnail",
  "thumbnailFallbackIcon": "ingredient-list-module__KfaF-W__thumbnailFallbackIcon",
  "thumbnailImage": "ingredient-list-module__KfaF-W__thumbnailImage",
  "unit": "ingredient-list-module__KfaF-W__unit",
});
